package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserRoleAuthorizationsResponse(
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("active_profiles_count")
    val activeProfilesCount: Int? = null,
    @SerialName("authorizations")
    val authorizations: List<UserRoleAuthorization>? = null
)

@Serializable
data class UserRoleAuthorization(
    @SerialName("assignment_id")
    val assignmentId: String? = null,
    @SerialName("role_id")
    val roleId: Int? = null,
    @SerialName("role_name")
    val roleName: String? = null,
    @SerialName("tenant")
    val tenant: UserRoleAuthorizationTenant? = null,
    @SerialName("last_used_at")
    val lastUsedAt: String? = null
)

@Serializable
data class UserRoleAuthorizationTenant(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("school_name")
    val schoolName: String? = null,
    @SerialName("school_code")
    val schoolCode: String? = null
)
